import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 

class MetaTraderCredentialsRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    updateCredentials(metaTraderCredentials) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/metatrader-credentials`, metaTraderCredentials,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getCredentialsById(metaTraderCredentialsId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/metatrader-credentials/${metaTraderCredentialsId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getCredentialsByBrokerAccountId(brokerAccountId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/metatrader-credentials/broker-account/${brokerAccountId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteCredentials(metaTraderCredentialsId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/metatrader-credentials/${metaTraderCredentialsId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createCredentials(metaTraderCredentials) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/metatrader-credentials`, metaTraderCredentials,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createCredentialsFromPartner(metatraderCredentialsFromPartner){
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/metatrader-credentials/from-partner`,metatraderCredentialsFromPartner,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateAllTradesForMetaTraderCredential(metaTraderCredentials){
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/metatrader-credentials/update-all-trades`,metaTraderCredentials,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new MetaTraderCredentialsRepository();
